import React from 'react';
import Select from 'react-select';
import moment from 'moment';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
/*import classnames from 'classnames';*/
import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import FormHelper from '../../form.js';
import { toast } from 'react-toastify';
import toUTCtime from '../../../../helper/UTCtime.js';

// Phone number
/*import rrui from 'react-phone-number-input/rrui.css'
import rpni from 'react-phone-number-input/style.css'*/
import Phone from 'react-phone-number-input'
import 'react-phone-number-input/rrui.css' 


import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export default class ModalRemainderEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time          : null,
      time_UTC      : null,
      method        : 'email',
      email         : '',
      mobile        : '',
      aliasReminder : '',
      isProcess     : false,
    }
    this.dataValid = true;
    
    this.onUpdate        = this.onUpdate.bind(this);
    this.onUpdateSuccess = this.onUpdateSuccess.bind(this);
    this.onUpdateFailed  = this.onUpdateFailed.bind(this);
  }

  onUpdate() {
    if(!FormHelper.ValidateForm(this.state)) {return}
    this.setState({isProcess: true})
    Presenter.Update(RequestProperties.Update(this, this.onUpdateSuccess, this.onUpdateFailed))    
  }

  onUpdateSuccess(params, response) {
    toast.success("Update reminder has been successfully")
    this.props.closeModal();
    this.props.updateRow(true);
    this.setState({isProcess: false})
  }

  onUpdateFailed(response) {
    this.props.updateRow(false);
    if(response.data !== null && response.data !== undefined && response.data.hasOwnProperty('Email')) {
      toast.error(response.data.Email[0]);
    } else if (response.data !== null && response.data !== undefined && response.data.hasOwnProperty('Time')) {
      toast.error('Datetime has wrong format');
    } else {
      toast.error(response.data.detail)
    }
    this.setState({isProcess: false})
  }

  onChangeTime(date) {
    
    let tmpDate = new Date(date._d)
    
    this.setState({
      time     : date,
      time_UTC : toUTCtime(tmpDate)
    })

  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.updateData === null) {
      this.dataValid = false;
    } else {
      this.dataValid = true;
      let tmpDate = moment(nextProps.updateData.Time)
      let date = tmpDate._d;
      
      this.setState({
        time          : moment(nextProps.updateData.Time),
        time_UTC      : toUTCtime(date),
        method        : nextProps.updateData.Method,
        email         : nextProps.updateData.Email,
        mobile        : nextProps.updateData.Mobile,
        aliasReminder : nextProps.updateData.Alias
      })
    }
  }

  renderMethod(method) {
    if(method === 'email') {
      return(
        <div className="form-group col-sm-12">
          <label className="required">Email</label>
          <input 
            name="email"
            type="email" 
            value={this.state.email}
            className="form-control"
            onChange={(e)=>this.setState({email: e.target.value})}
          />
        </div>
      )
    } else if (method === 'mobile') {
      return (
        <div className="form-group col-sm-12">
          <label className="required">Phone Number</label>
          <Phone
            placeholder="Enter phone number"
            className="form-control"
            value={ this.state.mobile }
            onChange={(val)=>this.setState({mobile: val}) } 
          />
        </div>
      )
    } else {
      return (
        <div className="col-sm-12">
          <div className="form-group ">
            <label className="required">Email</label>
            <input 
              name="email"
              type="email" 
              value={this.state.email}
              className="form-control"
              onChange={(e)=>this.setState({email: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label className="required">Phone Number</label>
            <Phone
              placeholder="Enter phone number"
              className="form-control"
              value={ this.state.mobile }
              onChange={ mobile => this.setState({ mobile }) } 
            />
          </div>
        </div>
      )
    }
  }

  render() {
    if(!this.dataValid) return(null)

    const {
      modalEdit, 
      className,  
      closeModal
    } = this.props;

    const {
      time, 
      method,  
      isProcess
    } = this.state;

    let buttonSave = null;
    if(isProcess) {
      buttonSave = <Button color="default"><i className='fa fa-spinner fa-pulse fa-fw'></i>&nbsp;Saving</Button>
    } else {
      buttonSave = <Button color="primary" onClick={()=>this.onUpdate()}>Save</Button>
    }

    return (
      <Modal isOpen={modalEdit} toggle={()=>closeModal()}  className={className}>
        <ModalHeader toggle={()=>closeModal()}>Edit Reminder</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-12">
              <label>Method <small>(default email)</small></label>
              <Select
                name="method"
                placeholder="Type Method"
                value={method}
                options={[
                  { value: 'email', label: 'Email' },
                  { value: 'mobile', label: 'Mobile' },
                  { value: 'both', label: 'Both' },
                ]}
                clearable={false}
                multi={false}
                onChange={(val) => this.setState({method: val.value})}
              />
            </div>
            {this.renderMethod(method)}
            <div className="form-group col-sm-12">
              <label className="required">Remainder Time</label>
              <DatePicker
                className="form-control"
                minDate ={moment()}
                selected={time}
                onChange={(e)=> this.onChangeTime(e) }
                timeFormat="HH:mm"
                timeIntervals={60}
                dateFormat="lll"
                showTimeSelect
                readOnly
              />
            </div>

          </div>
        </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={()=>closeModal()}>Cancel</Button>
            {buttonSave}
          </ModalFooter>
        </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/remainder/helper/component/Modal/ModalRemainderEdit.js